exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pie[data-v-1756d704]{position:relative;width:18px;height:18px;border-radius:100%;list-style:none;overflow:hidden;background:#f3f3f3}.slice[data-v-1756d704]{overflow:hidden;position:absolute;top:0;right:0;width:50%;height:50%;transform-origin:0 100%}.slice-1[data-v-1756d704]{transform:rotate(0deg) skewY(0deg);background:#f3f3f3;z-index:4}.slice-2[data-v-1756d704]{transform:rotate(-90deg) skewY(0deg);background:#f3f3f3;z-index:1}.slice-3[data-v-1756d704]{transform:rotate(-180deg) skewY(0deg);background:#f3f3f3;z-index:2}.slice-4[data-v-1756d704]{transform:rotate(-270deg) skewY(0deg);background:#f3f3f3;z-index:3}", ""]);

// exports
